import { computed, ref, toRaw, watch } from 'vue'

import axios from 'axios'

const work_fronts = ref([])
const dropdown_data = ref({
  machines: [],
  confined_spaces: [],
  company_sectors: [],
  noncompliance_model_degrees_of_risk: []
})
const total_work_fronts = ref(0)
const loading = ref(false)

export default function useWorkFront() {
  const listWorkFront = async (company_id, page, per_page) => {
    axios
      .get('/api/work-front/list/'+company_id, {
        params : {
          page,
          per_page
        }
      })
      .then(response => {
        work_fronts.value = response.data.data;
        total_work_fronts.total = response.data.data;
      })
      .catch(() => {})
  }

  const listAllWorkFronts = async (company_id) => {
    return await axios
      .get('/api/work-front/all-grouped', {
        params: { company_id: company_id },
      })
      .then(response => {
        work_fronts.value = response.data.data;
        total_work_fronts.total = response.data.data;
      })
      .catch(() => {})
  }

  const getDropdownData = async (company_id) => {
    return await axios
      .get('/api/work-front/get-dropdown-data/' + company_id)
      .then((response) => {
        dropdown_data.value = response.data;
      })
  }

  const destroyWorkFront = async (event) => {
    await axios
      .delete('/api/work-front/destroy/' + event.id)
      .then(() => {
        confined_spaces.value.splice(event.index, 1)
      })
      .catch(() => {})
  }

  const storeOrUpdateWorkFront = async (data) => {
    return axios
      .post('/api/work-front/storeOrUpdate', data)
  }

  return {
    work_fronts: computed(() => work_fronts.value),
    dropdown_data: computed(() => dropdown_data.value),
    total_work_fronts: computed(() => total_work_fronts.value),
    loading,
    listWorkFront,
    listAllWorkFronts,
    destroyWorkFront,
    storeOrUpdateWorkFront, 
    getDropdownData
  }
}
